import React, { useState, useEffect, Fragment } from "react";
import { useParams, useHistory, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { order_actions } from "../../../../redux-store";

const AccountInfo = (props) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const { user } = useSelector((state) => state.auth);
  const allorders = useSelector((state) => state.order);
  

  const [state, setState] = useState(null);
  const [orders, setOrders] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      if (pathname.includes(user?.user?.role)) {
        const myOrders = allorders?.orders?.filter(
          (x) => x?.items?.[0]?.product?.merchant_user?._id === user.user._id
        );
        setState(user.user);
        setOrders(myOrders?.length);
      } else {
        history.replace(`/dashboard/${user?.user?.role}`);
      }
    }
  }, [user, pathname, allorders]);
  useEffect(() => {
    dispatch(
      order_actions.fetch_orders({
        limit: 99999999,
        merchantId: user?.user?._id,
      })
    );
  }, []);
  console.log("state",state)
  return (
    <Fragment>
      <Helmet>
        <title>eksplode! | Account Info</title>
      </Helmet>
      {state && (
        <div className="dashboard">
          <div className="page-title">
            <h2>My Dashboard</h2>
          </div>
          <div className="welcome-msg">
            <h3>
              <small>Hello, </small>
              {`${state.first_name} ${state.last_name}`}
            </h3>
            <p>
              From your My Account Dashboard you have the ability to view a
              snapshot of your recent account activity and update your account
              information.
            </p>
          </div>
          <div className="box-account box-info">
            <div className="box-head">
              <h2>Account Information</h2>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="box">
                  <div className="box-title">
                    <h3>Contact Information</h3>
                  </div>
                  <div className="box-content">
                    {pathname.includes("customer") && <h6>{state.phone}</h6>}
                    <h6>{state.email}</h6>
                    <h6>
                      <Link to={`${pathname}/change-password`}>
                        Change Password
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="box">
                  <div className="box-title">
                    <h3>eksplode! Code</h3>
                  </div>
                  <div className="box-content">
                    <h6>{state.eksplode_code}</h6>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="box">
                  <div className="box-title">
                    <h3>Total Orders</h3>
                    <Link to={`${pathname}/orders`}>View Orders</Link>
                  </div>
                  <div className="box-content">
                    <p>{orders}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default AccountInfo;
